import { useHasTreasury, useIsEntrepeneur } from '~/hooks/useFeatureFlag';
import { useUserBankAccountPermissions } from '~/hooks/useUserBankAccountPermissions';

/**
 * Whether the logged-in user has access only to the Sibill/Swan account (card-only collaborator):
 * no Treasury feature, not an entrepreneur, but with an enabled Swan bank account.
 */
export const useIsOnlySwan = (): { isOnlySwan: boolean; isResolving: boolean } => {
  const hasTreasury = useHasTreasury();
  const isEntrepreneur = useIsEntrepeneur();
  const { isSibillAccountEnabled, isLoading, isError } = useUserBankAccountPermissions();

  return {
    isOnlySwan: !hasTreasury && !isEntrepreneur && isSibillAccountEnabled,
    isResolving: isLoading || isError,
  };
};
